<template>
  <article>
    <!--<div ref="slider" class="slider" role="slider">
      <ul class="slides">
        <li>
          <img
            src="../assets/images/Ponte-do-Saber-Raphael-Pizzino2.jpg"
            alt="Ponte do Saber/UFRJ - Raphael Pizzino"
          />
          <div class="caption center-align">
            <header>
              <h1 class="white-text">{{ title }}</h1>
            </header>
          </div>
        </li>
      </ul>
    </div>-->
    <div id="container-img">
      <div v-if="isUserLoggedIn">
        <TheModulosPanel />
      </div>
      <div v-else>
        <section class="section container home-card" v-if="isUserLoggedIn">
          <BaseCard color="white" class="center">
            <template v-slot:card-content>
              <i class="material-icons medium" v-bind:class="[textColor, textLuminosity]">checklist</i>
              <span class="home-card-title">Objetivos</span>
              <p>{{ message }}</p>
            </template>
          </BaseCard>
        </section>
      </div>
    </div>
  </article>
</template>

<script>
import { APP_INFO, DEFAULT_COLOR, DEFAULT_LUMINOSITY } from "../constants";
import TheModulosPanel from "../components/TheModulosPanel.vue";

export default {
  name: "Início",
  components: {
    TheModulosPanel
  },
  inheritAttrs: false,
  computed: {
    isUserLoggedIn() {
      // Não utiliza o método `AuthenticationService.isAuthenticated` pois
      // ele também verifica se a sessão ainda está ativa. Aqui, apenas
      // preciso saber se o usuário acessou o sistema recentemente
      return !this.$utils.Lang.isNullOrUndefined(
        this.$store.state.authenticationData
      );
    },
  },
  data() {
    return {
      message: `O ${APP_INFO.name} é o novo sistema de gestão de pessoal da UFRJ.`,
      textColor: `${DEFAULT_COLOR}-text`,
      textLuminosity: DEFAULT_LUMINOSITY ? `text-${DEFAULT_LUMINOSITY}` : "",
      title: ``
    };
  },
  /*beforeCreate() {
    if (!window.M) {
      window.console.error(
        "Objeto do Materialize não encontrado. Verifique se essa biblioteca foi carregada corretamente"
      );
    }
  },
  mounted() {
    if (!window.M) {
      return;
    }

    window.M.Slider.init(this.$refs.slider, {
      indicators: false,
      height: 710,
      transition: 600,
      interval: 6000
    });
  },
  beforeDestroy() {
    if (!window.M) {
      return;
    }

    const instance = window.M.Slider.getInstance(this.$refs.slider);

    if (instance) {
      instance.destroy();
    }
  }*/
};
</script>

<style scoped>
#container-img {
  background-color: rgb(0, 0, 0);
  background-image: url("../assets/images/Ponte-do-Saber-Raphael-Pizzino2.jpg");
  background-size: cover;
  background-position: center;
  width: 100vw;
  min-height: calc(100vh - 90px);
  padding: 3% 15%;
  align-content: center;
}

/*
.slider .caption {
  margin-top: -50px;
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.3);
}

@media screen and (min-width: 0px) {
  .slider .caption h1 {
    font-size: 3rem;
    font-weight: 300;
  }
}

@media screen and (min-width: 601px) {
  .slider .caption h1 {
    font-size: 3.5rem;
    font-weight: inherit;
  }
}
*/
.home-card {
  opacity: 0.7;
}

.home-card /deep/ .home-card-title {
  display: block;
  font-size: 1.64rem;
  line-height: 110%;
  margin: 1.0933333333rem 0 0.656rem 0;
}

/* Ajuste para aumentar a seletividade das regras de alto contraste */
/*.contrast .slider .caption {
  background: transparent !important;
};*/
.contrast .home-card i.material-icons {
  color: white !important;
}
</style>
